import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "vuetify";
import VGoogleTranslate from "v-google-translate";

import "./setup/index";

//  引入公共组件
import "./framework/index";
//  引入全局样式
import "./scss/_index.scss";

//  引入Vuetify样式
import "./vendor/vuetify.css";

//  Plugin
// import  "./vendor/vuetify.js";

Vue.use(vuetify);
Vue.use(VGoogleTranslate);

new Vue({
    el: "#app",
    router,
    store,
    vuetify: new Vuetify({}),
    render: h => h(App)
});

import Vuetify from "vuetify";
